import { render, staticRenderFns } from "./judges_filter.vue?vue&type=template&id=84c85890&scoped=true"
import script from "./judges_filter.vue?vue&type=script&lang=js"
export * from "./judges_filter.vue?vue&type=script&lang=js"
import style0 from "./judges_filter.vue?vue&type=style&index=0&id=84c85890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c85890",
  null
  
)

export default component.exports